export let options_messageorganization_searchterms = "V$lwic";
export default {options_messageorganization_searchterms};